The free-form description of the action.
